import { render, staticRenderFns } from "./honour.vue?vue&type=template&id=6397f400&scoped=true"
import script from "./honour.vue?vue&type=script&lang=js"
export * from "./honour.vue?vue&type=script&lang=js"
import style0 from "./honour.vue?vue&type=style&index=0&id=6397f400&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6397f400",
  null
  
)

export default component.exports